import { PlaylistService } from './../../api/services/playlist-service';
import {Component, OnInit, Input} from '@angular/core';
import {SongsService, UserService, MessagesServices} from '../../api/';
import {ToastyService, ToastOptions} from 'ng2-toasty';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {AuthService} from '../../api/';
import {Router} from '@angular/router';
import {Helper} from '../../helper';
import * as _ from 'lodash';

@Component({
    selector: 'add-to-discovery',
    templateUrl: './add-to-discovery.component.html',
    styleUrls: ['./add-to-discovery.component.css']
})
export class AddToDiscoveryComponent implements OnInit {
    @Input() item: any;
    @Input() aboveTooltip: string = 'below';
    private messages: any = new Array<any>();
    msg1: any = '';
    title1: any = '';
    msg2: any = '';
    title2: any = '';
    msg3: any = '';
    title3: any = '';
    msg4: any = '';
    title4: any = '';
    private helper = new Helper();
    @BlockUI() blockUI: NgBlockUI;
    public onlineOffline1: boolean = navigator.onLine;

    constructor(private userService: UserService, private songsService: SongsService, private sm: MessagesServices, private toastyService: ToastyService, public authService: AuthService, private router: Router, private playlistService: PlaylistService) {
        window.addEventListener('online', () => {this.onlineOffline1 = true; });
        window.addEventListener('offline', () => {this.onlineOffline1 = false});
        this.messages = this.sm.messags;
        this.setMessages();
    }

    ngOnInit() {
        this.item._type = (typeof this.item._type === 'undefined') ? 'playlist' : this.item._type;
    }

    /**
     * getting system messages
     **/
    setMessages() {
        this.msg1 = '';
        this.title1 = '';
        this.msg2 = '';
        this.title2 = '';
        this.msg3 = '';
        this.title3 = '';
        this.msg4 = '';
        this.title4 = '';
        if (this.messages) {
            for (var i = 0; i < this.messages.length; i++) {
                if (this.messages[i].event == 'WG_EVENT_ADDED_TO_DISCOVERIES') {
                    this.title1 = this.messages[i].title;
                    this.msg1 = this.messages[i].message;
                }
                if (this.messages[i].event == 'WG_EVENT_CANNOT_ADD_TO_DISCOVERIES') {
                    this.title2 = this.messages[i].title;
                    this.msg2 = this.messages[i].message;
                }
                if (this.messages[i].event == 'WG_EVENT_REMOVED_FROM_DISCOVERIES') {
                    this.title3 = this.messages[i].title;
                    this.msg3 = this.messages[i].message;
                }
                if (this.messages[i].event == 'WG_EVENT_CANNOT_REMOVE_FROM_DISCOVERIES') {
                    this.title4 = this.messages[i].title;
                    this.msg4 = this.messages[i].message;
                }
            }
        }
    }

    addToDiscoveries(event) {
        if (!this.authService.isUserLoggedIn()) {
            return this.router.navigate(['/login']);
        }
        event.stopPropagation();
        event.preventDefault();
        this.blockUI.start('Loading, please wait...');
        if(this.onlineOffline1) {
            this.songsService.addSongToDiscoveries({item: this.item}).subscribe((res) => {
                // song success fully discovered
                this.item.discoveredByMe = true;
                let toastOptions: ToastOptions = {
                    title: this.title1,
                    msg: this.msg1,
                    showClose: true,
                    timeout: 2000,
                    theme: 'default'
                };
                this.toastyService.success(toastOptions);
                this.blockUI.stop();
                this.item.discoveredByMe = true;
                this.getDiscoveries(this.item, 1);
                this.updateSongDiscoveryStatus(this.item.id, 1);
            }, (err) => {
                let toastOptions: ToastOptions = {
                    title: this.title2,
                    msg: this.msg2,
                    showClose: true,
                    timeout: 2000,
                    theme: 'default'
                };
                this.toastyService.error(toastOptions);
                this.blockUI.stop();
            });
        } else {
            this.blockUI.stop();
        }

    }

    removeFromDiscoveries(event) {
        if (!this.authService.isUserLoggedIn()) {
            return this.router.navigate(['/login']);
        }
        event.stopPropagation();
        event.preventDefault();
        this.blockUI.start('Loading, please wait...');
        this.songsService.removeSongFromDiscoveries({item: this.item}).subscribe((res) => {
            // song success fully discovered
            let toastOptions: ToastOptions = {
                title: this.title3,
                msg: this.msg3,
                showClose: true,
                timeout: 2000,
                theme: 'default'
            };
            this.toastyService.success(toastOptions);
            this.item.discoveredByMe = false;
            this.getDiscoveries(this.item, 0);
            this.updateSongDiscoveryStatus(this.item.id, 0);
        }, (err) => {
            let toastOptions: ToastOptions = {
                title: this.title4,
                msg: this.msg4,
                showClose: true,
                timeout: 2000,
                theme: 'default'
            };
            this.toastyService.error(toastOptions);
            this.blockUI.stop();
        });
    }

    getDiscoveries(item: any, status: number) {
        let type = "discoveries";
        let discoveries = [];
        discoveries = JSON.parse(localStorage.getItem(type));
        if(status == 1) {
            let song = {};
            song['domain'] = item._type;
            song['object'] = item.id;
            song['isHovering'] = false;
            song['item'] = item;
            if(discoveries == null) {
                discoveries = [];
            }
            const found = discoveries.some(el => el.item.id === item.id);
            if (!found) {
                discoveries.push(song);
            }
            discoveries.forEach(element => {
                element.item.isSongDownloaded = ((!element.item.isSongDownloaded) ? 'Streaming' : 'Owned');
            });
            this.helper.setLocalStore(type, discoveries);
        } else if(status == 0) {
            discoveries.splice(discoveries.findIndex(obj => obj.item.id === item.id), 1);
            discoveries.forEach(element => {
                element.item.isSongDownloaded = ((!element.item.isSongDownloaded) ? 'Streaming' : 'Owned');
            });
            this.helper.setLocalStore(type, discoveries);
            this.playlistService.isMyDiscoveryUpdated.next(item.id);
        }
    }

    // To Update the status of Add to Discovery attribute for songs from local storage
    updateSongDiscoveryStatus(id:number, status:number) {
        let downloadType = "mostDownload";
        let mostDownloaded = JSON.parse(localStorage.getItem("mostDownload"));
        let playedType = "mostPlayed";
        let mostPlayed = JSON.parse(localStorage.getItem("mostPlayed"));
        let newType = "mostNew";
        let mostNew = JSON.parse(localStorage.getItem("mostNew"));
        if(mostDownloaded) {
            mostDownloaded.forEach((element, index) => {
                if(element.id) {
                    if(element.id === id && status == 1) {
                        element.discoveredByMe = true;
                    } else if(element.id === id && status == 0) {
                        element.discoveredByMe = false;
                    }
                }
                this.helper.setLocalStore(downloadType, mostDownloaded);
            });
        }
        if(mostPlayed) {
            mostPlayed.forEach((element, index) => {
                if(element.id) {
                    if(element.id === id && status == 1) {
                        element.discoveredByMe = true;
                    } else if(element.id === id && status == 0) {
                        element.discoveredByMe = false;
                    }
                }
            });
            this.helper.setLocalStore(playedType, mostPlayed);
        }
        if(mostNew) {
            mostNew.forEach((element, index) => {
                if(element.id) {
                    if(element.id === id && status == 1) {
                        element.discoveredByMe = true;
                    } else if(element.id === id && status == 0) {
                        element.discoveredByMe = false;
                    }
                }
            });
            this.helper.setLocalStore(newType, mostNew);
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/add-to-discovery/add-to-discovery.component.ts